import React, {useEffect, useState} from 'react';
import {RowType} from "../../models/api/codegen/code";
import {ActionBox} from "../Actions/ActionBox";
import {Visible} from "../../utils/Visible";
import {useTranslation} from "react-i18next";
import {getChessLiveSportId} from "../../spirsApi/api-client";
import {useSelector} from "react-redux";
import {StoreType} from "../../store/spirs/types";

export const ActionBoxes: React.FC<RowType> = (row) => {
    const {t} = useTranslation();
    const [chess, setChess] = useState<Number | null>(null);
    const player = useSelector((state: StoreType) => state.spirs.playerInfo.playerId);

    useEffect(() => {
        player && getChessLiveSportId({player}).then(res => res && setChess(res.value))
    }, [player]);

    if (!row.cards) {
        return <></>
    }

    return (
        <div className="grid grid-cols-3 tablet:grid-cols-2 notebook:grid-cols-3 desktop:grid-cols-4 desktop2560:grid-cols-6 m-[-5px] tablet:m-[-8px]">
            {row.cards.map((card, i) => (
                <Visible key={i} value={card.type !== 'chess' || !!chess}>
                    <ActionBox
                      linkTo={card.type !== 'chess' ? card.route : card.route + chess}
                      boxMessage={card.title ? (card.translate ? t(card.title) : card.title) : ''}
                      imgPath={card.value}
                    />
                </Visible>
            ))}
        </div>
    )
}
